<template>
	<div>
		<div class="items">
			<div class="items-body">

				<div class=inputCard>
				<span class="apiKeys">{{ $t('email') }} </span>
				<!-- <quick-edit 
					type="text"
					maxlength=50  
					:emptyText="$t('companyEmailMissing')"
					:placeholderValue="$t('companyName')" 
					:buttonOkText="'✔'"
					input
					@input="changeClientDetails('email_general')"
					:buttonCancelText="'X'"
					:classes="vueQuickEditClasses" 
					v-model="client.email_general">
				</quick-edit> -->
				<br />
				<span 
					class="field-value active" 
					v-show="!showField('email_general')"
					@click="focusField('email_general')">
					{{client.email_general}}</span>
					<input 
					v-show="showField('email_general')"
					class="field-value form-control inactive"
					v-model="client.email_general"
					maxlength="50" 
					type="text" 
					@focus="focusField('email_general')" 
					@blur="$v.client.email_general.$touch(); blurField('email_general')"
				/>
				<template v-if="$v.client.email_general.$invalid">
					<div v-if="!$v.client.email_general.required" class="errorMessage">{{ $t('emailReq') }}</div>
				</template>
				<template v-if="$v.client.email_general.$invalid">
					<div v-if="!$v.client.email_general.email" class="errorMessage1">{{ $t('emailValid') }}</div>
				</template>
				<template v-if="$v.client.email_general.$invalid">
					<p v-if="!$v.client.email_general.maxLength" class="errorMessage1">
						{{ $t('emailLength') }}
					</p>
				</template>
				</div>
				<!-- <div class=inputCard>
				<span class="apiKeys">{{ $t('invoicingEmail') }} </span>
				<br />
				<input 
					v-show="!showField('email_invoice')" 
					class="field-value active" placeholder="Empty" 
					v-model="client.email_invoice"
					@click="focusField('email_invoice')"
				/>
				<input 
					v-show="showField('email_invoice')"
					class="field-value form-control inactive"
					v-model="client.email_invoice" 
					type="text" 
					@focus="focusField('email_invoice')" 
					@blur="$v.client.email_invoice.$touch(); blurField('email_invoice')"
				/>
				<template v-if="$v.client.email_invoice.$invalid">
					<div v-if="!$v.client.email_invoice.email" class="errorMessage1">{{ $t('emailValid') }}</div>
				</template>
				</div> -->


				
				<div>
				<!-- <span class="apiKeys">{{ $t('contactPerson') }} </span> -->
				<div class="nameWrapper">
					<div class="inputCard">
					<span class="apiKeys">{{ $t('name') }} </span>
					<!-- <quick-edit 
						type="text"
						maxlength=50  
						:emptyText="$t('empty')"
						:placeholderValue="$t('companyName')" 
						:buttonOkText="'✔'"
						input
						@input="changeClientDetails('contact_fname')"
						:buttonCancelText="'X'"
						:classes="vueQuickEditClassesShortInput" 
						v-model="client.contact_fname">
					</quick-edit> -->
					<br />
					<span 
						class="field-value active"
						v-show="!showField('contact_fname')"
						@click="focusField('contact_fname')">
						{{client.contact_fname}}</span>
						<input 
						v-show="showField('contact_fname')"
						class="field-value form-control inactive"
						v-model="client.contact_fname"
						type="text"
						maxlength=30
						@focus="focusField('contact_fname')"
						@blur="$v.client.contact_fname.$touch(); blurField('contact_fname')"
							/>
					</div>
					<div class="inputCard">
					<span class="apiKeys">{{ $t('surname') }} </span>
					<!-- <quick-edit 
						type="text"
						maxlength=50  
						:emptyText="$t('empty')"
						:placeholderValue="$t('companyName')" 
						:buttonOkText="'✔'"
						input
						@input="changeClientDetails('contact_lname')"
						:buttonCancelText="'X'"
						:classes="vueQuickEditClassesShortInput" 
						v-model="client.contact_lname">
					</quick-edit> -->
					<br />
					<span 
						class="field-value active" 
						v-show="!showField('contact_lname')"
						@click="focusField('contact_lname')">
						{{client.contact_lname}}</span>
						<input 
							v-show="showField('contact_lname')"
							class="field-value form-control inactive"
							v-model="client.contact_lname" 
							type="text" 
							maxlength=30 
							@focus="focusField('contact_lname')" 
							@blur="$v.client.contact_lname.$touch(); blurField('contact_lname')"
					/>
					</div>
				</div>


					<!-- <input 
					class="inactive" 
					v-model="client.contact_fname" 
					type="text" 
					:disabled="!isEditing"
					:placeholder="$t('name')"
					:class="{ active: !isActive, view: !isEditing }" 
					/> -->
					<!-- <input 
					class="inactive mg-left " 
					v-model="client.contact_lname" 
					type="text" 
					:disabled="!isEditing"
					:placeholder="$t('surname')"
					:class="{ active: !isActive, view: !isEditing }" 
					/> -->
				</div>

				<div class=inputCard>
				<span class="apiKeys">{{ $t('contactNo') }} </span>
				<!-- <quick-edit 
					type="number"
					maxlength=20  
					:emptyText="$t('companyContactNoMissing')"
					:placeholderValue="$t('companyName')" 
					:buttonOkText="'✔'"
					input
					@input="changeClientDetails('contact_no')"
					:buttonCancelText="'X'"
					:classes="vueQuickEditClasses" 
					v-model="client.contact_no">
				</quick-edit> -->
					<br />
					<span 
					class="field-value active" 
					v-show="!showField('contact_no')"
					@click="focusField('contact_no')">
					{{client.contact_no}}</span>
					<input 
					v-show="showField('contact_no')"
					class="field-value form-control inactive"
					v-model="client.contact_no" 
					oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
					maxlength="13"
					@focus="focusField('contact_no')" 
					@blur="$v.client.contact_no.$touch(); blurField('contact_no')"
					/>
				<template v-if="$v.client.contact_no.$error">
					<div v-if="!$v.client.contact_no.required" class="errorMessage">{{ $t('contactNoReq') }}</div>
					<div v-else class="errorMessage">
						<br />{{ $t('contactRegexValidation') }}
					</div>
				</template>
				</div> 

				<div class=inputCard>
				<span class="apiKeys">{{ $t('website') }} </span>
				<!-- <quick-edit 
					type="url"
					maxlength=50  
					:emptyText="$t('empty')"
					:placeholderValue="$t('companyName')" 
					:buttonOkText="'✔'"
					input
					@input="changeClientDetails('website_url')"
					:buttonCancelText="'X'"
					:classes="vueQuickEditClasses" 
					v-model="client.website_url">
					</quick-edit> -->
				<br />
				<span 
					class="field-value active" 
					v-show="!showField('website_url')"
					@click="focusField('website_url')">
					{{client.website_url}}</span>
				<input 
					v-show="showField('website_url')"
					class="field-value form-control inactive"
					v-model="client.website_url"
					maxlength="100" 
					type="text" 
					@focus="focusField('website_url')" 
					@blur="$v.client.website_url.$touch(); blurField('website_url')"
				/>
				<template v-if="$v.client.website_url.$invalid">
					<br/>
					<div v-if="!$v.client.website_url.url" class="errorMessage1">{{ $t('validUrlReq') }}</div>
				</template>
				</div>
				<hr>
				<p class="editInstructions">{{ $t('editInstructions') }}</p>

				<!-- <div>
				<button :disabled="$v.$invalid" class="save-btn" v-if="isEditing" @click="changeClientDetails"><span class="save-txt">{{ $t('save') }}</span></button>
				</div> -->

			</div>
		</div>

	</div>
</template>

<script>
import { required, email, url, maxLength, helpers } from 'vuelidate/lib/validators'
const contactNoRegex = helpers.regex('contact_no', /^([+][0-9]{11,12})$/)

export default {
  data() {
    return {
      id: this.client.id,
      isEditing: false,
      isActive: false,
      vueQuickEditClasses: {
        wrapper: 'form-group form-inline',
        input: 'formControl input-sm',
        buttons: 'btn-group btn-group-sm',
        buttonOk: 'btn saveBtn',
        buttonCancel: 'btn closeBtn',
      },
      vueQuickEditClassesShortInput: {
        wrapper: 'form-group form-inline',
        input: 'formControl short input-sm',
        buttons: 'btn-group btn-group-sm',
        buttonOk: 'btn saveBtn',
        buttonCancel: 'btn closeBtn',
      },
      editField : ''
    }
  },
   validations: {
    client: {
      email_general: { required, email, maxLength: maxLength(70) },
      email_invoice: { email },
      contact_fname: { },
      contact_lname: { },
      contact_no: { required, contactNoRegex },
      website_url: { url },
    }
  },
  methods: {
    focusField(name){
      this.editField = name;
    },
    blurField(name){
      this.editField = '';
	  if (!this.$v.client[name].$invalid) {
		this.changeClientDetails(name)
	  }
    },
    showField(name){
      return (this.client[name] == '' || this.client[name] == null || this.editField == name)
    },
    changeClientDetails(propertyName) {
      if (this.client[propertyName] === "") {
        return
      }
      // if (
      //   confirm('are you sure? This will rewrite excisting contact details')
      // ) 
      {
        this.$store.dispatch('client/editClient', this.client)
        this.isEditing = !this.isEditing
        this.isActive = !this.isActive
      }
    }
  },
  props: {
    client: {
      type: Object,
      required: true
    }
  }
}
</script>

<style lang="scss" scoped>

$sec:#fff;
$primary: #b97b42;
$dark-pri:rgb(44, 62, 80);
* {
  box-sizing: border-radius;
 }

::-webkit-input-placeholder {
 color:#FF6961;
}
:-moz-placeholder {
 color:#FF6961;
}
::-moz-placeholder {
 color:#FF6961;
}
:-ms-input-placeholder {
 color:#FF6961;
}

.active {
    border-radius: 3.5px;
    background: none !important;
    font-weight: 600;
    font-style: normal !important;
	white-space: normal !important;
}
.inactive {
    background-color: var(--primarySuperLight);
    border-radius: 3.5px;
	white-space: normal !important;
    // font-style: italic;
}

.errorMessage1 {
  margin-bottom: 0.2em;
  color: var(--primaryDark);
  font-size: 0.58em;
}
.errorMessage {
margin-top: -15px;
  margin-bottom: 0.2em;
  padding-left: 5px;
  padding-top: 4px;
  color: var(--primaryDark);
  font-size: 0.58em;
}

.nameWrapper {
  display: flex;
}
.nameWrapper > .inputCard {
  margin-right: 20px;
}

.mg-left {
  margin-left: 15px;
}

.inputCard {
  padding: 10px;
}

.editInstructions {
color: var(--grey);
font-size: 0.8em;
} 
 
.add-btn {
  background: var(--primaryDark);
  color: var(--bright);
  padding: 0.3em;
  border-radius: 5px;
  letter-spacing: 3px;
  max-width: 150px;
  width:100%;
  margin-left: 30px;
  margin-bottom: 20px;
}

.save-btn {
    background: var(--primaryDark);
    color: var(--bright);
    padding: 0.3em;
    margin: auto !important;
    letter-spacing: 3px;
    border: none;
    border-radius: 3.5px;
    width: 120px;
    height: 30px;
}

.items {
  width: 100%;
  max-width: 750px;
  background: $sec;
  box-shadow: 0 3px 6px rgba(black,0.16), 0 3px 6px rgba(black,0.23);
  border-top: 10px solid var(--primaryDark);
}

.items-head p{
  padding: 5px 20px;
  margin: 10px;
  color: $dark-pri;
  font-weight: bold;
  font-size: 20px;
}

.items-head hr {
  width: 20%;
  margin: 0px 30px;
  border: 1px solid $dark-pri;
}
.apiKeys {
  color: var(--grey);
  text-align: left;
  font-size: 1.1vw;
}
.items-body {
  padding: 10px;
  text-align: left;
  margin-left: 20px;
}

button:disabled,
button[disabled]{
  border: 1px solid #999999;
  background-color: #cccccc;
  color: #666666;
  cursor: context-menu;
}

.items-body-content {
  padding: 10px;
  padding-right: 0px;
  display: grid;
  grid-template-columns: 10fr 1fr;
  // background-color: lightblue;
  font-size: 13px;
  grid-gap: 10px;
  border: 1px solid transparent;
  cursor: pointer;
  
}

.items-body-content:hover {
  border-radius: 15px;
  border: 1px solid $dark-pri;
}

.items-body-content i {
  align-self: center;
  font-size: 15px;
  color: $dark-pri;
  font-weight: bold;
  animation: icon 1.5s infinite forwards;
}

.save-txt {
  // margin-left: 5px;
  padding: 7px;
}

@keyframes icon {
  0%,100%{
    transform: translate(0px);
  }
  50% {
    transform: translate(3px);
  }
}
@media screen and (max-width: 900px) {
  .apiKeys {
    font-size: 1.05em;
  }
}
@media screen and (max-width: 600px) {
  .apiKeys {
    font-size: .95em;
  }
  .items-body {
    margin-left: 8px;
  }
}

@media screen and (max-width: 400px) {
  .add-btn {
    font-size: 0.6em;
  }
  .inputCard {
  padding: 5px;
  margin-right: 0px !important;
}
  .apiKeys {
    font-size: .8em;
  }
  .items-body {
    margin-left: 5px;
  }
  .nameWrapper {
	margin-right: 0px !important;
	display: block;
  }
}

</style>